module.exports = __webpack_public_path__ + "static/media/done.896d2053.svg";